import { shellStringResources } from '../Resources/ShellStringResources';

export enum AuthenticationType {
    ServicePrincipal = 'Service principal',
    AccountKey = 'Account Key',
    ManagedServiceIdentity = 'Managed service identity',
    Basic = 'Basic',
    Anonymous = 'Anonymous',
    Windows = 'Windows',
    SQL = 'SQL',
    SqlOrManagedServiceIdentity = 'Sql or Managed service identity', // for UI only, won't passed to backend
    Credential = 'Credential',
    AccessToken = 'Access Token',
    UserAssignedManagedIdentity = 'User Assigned Managed Identity',
    UserAuth = 'UserAuth',
    WorkspaceIdentity = 'WorkspaceIdentity'
}

export enum SQLAuthenticationType {
    SQL = 'SQL',
    Windows = 'Windows',
    ServicePrincipal = 'ServicePrincipal',
    ManagedServiceIdentity = 'SystemAssignedManagedIdentity',
    UserAssignedManagedIdentity = 'UserAssignedManagedIdentity',
    UserAuth = 'UserAuth',
    Credential = 'Credential',
    SqlOrManagedServiceIdentity = 'Sql or Managed service identity'
}

export enum AuthenticationReferenceType {
    Inline = 'Inline',
    Credential = 'Credential'
}

// todo, check whether we can merge with AuthenticationReferenceType
export const azureDefaultAuthRefTypes = {
    CredentialRefTypeAuthentication: 'credential',
    InlineRefTypeAuthentication: 'inline'
};

export type AzureAuthTypes =
    | 'SQL'
    | 'Windows'
    | 'ServicePrincipalAuthentication'
    | 'AccountKeyAuthentication'
    | 'MSIAuthentication'
    | 'UserAssignedManagedIdentity'
    | 'SasUriAuthentication'
    | 'Credential'
    | 'UserAuth'
    | 'Anonymous'
    | 'SystemAssignedManagedIdentity'
    | 'ServicePrincipal';

export const azureBlobFSAuthTypes = {
    AccountKeyAuthentication: 'AccountKeyAuthentication',
    ServicePrincipalAuthentication: 'ServicePrincipalAuthentication',
    MSIAuthentication: 'MSIAuthentication',
    SasUriAuthentication: 'SasUriAuthentication',
    Credential: AuthenticationType.Credential,
    UserAssignedManagedIdentity: 'UserAssignedManagedIdentity',
    UserAuth: AuthenticationType.UserAuth,
    WorkspaceIdentity: AuthenticationType.WorkspaceIdentity
};

export const azurePostgreSqlAuthTypes = {
    ServicePrincipal: 'ServicePrincipal',
    Basic: AuthenticationType.Basic,
    SystemAssignedManagedIdentity: 'SystemAssignedManagedIdentity', // not support On-Prem now
    UserAssignedManagedIdentity: 'UserAssignedManagedIdentity'
};

export const azureStorageAuthTypes = {
    Anonymous: AuthenticationType.Anonymous,
    ...azureBlobFSAuthTypes
};

export const oDataAuthTypes = {
    BasicAuthentication: AuthenticationType.Basic,
    WindowsAuthentication: AuthenticationType.Windows,
    AnonymousAuthentication: AuthenticationType.Anonymous,
    AADServicePrincipalWithKey: 'ServicePrincipalKey',
    AADServicePrincipalWithCert: 'ServicePrincipalCert',
    MSIAuthentication: 'ManagedServiceIdentity',
    AADServicePrincipal: 'AadServicePrincipal',
    UserAuth: AuthenticationType.UserAuth
};

export const cosmosSqlAuthMethod = {
    connectionString: 'connectionString',
    servicePrincipal: 'servicePrincipal',
    managedIdentity: 'managedIdentity',
    userAssigedManagedIdentity: 'UserAssignedManagedIdentity',
    userAuth: AuthenticationType.UserAuth
};

export const sqlEncryptedAuthMethod = {
    servicePrincipal: 'ServicePrincipal',
    managedIdentity: 'ManagedIdentity',
    userAssigedManagedIdentity: 'UserAssignedManagedIdentity'
};

export const dynamicsAuthTypes = {
    Office365: 'Office365',
    Ifd: 'Ifd',
    AADServicePrincipal: 'AADServicePrincipal',
    ManagedIdentity: 'ManagedIdentity',
    ADAuth: 'ActiveDirectory',
    UserAuth: AuthenticationType.UserAuth
};

export const restAuthTypes = {
    Anonymous: AuthenticationType.Anonymous,
    Basic: AuthenticationType.Basic,
    AadServicePrincipal: 'AadServicePrincipal',
    ManagedServiceIdentity: 'ManagedServiceIdentity',
    OAuth2ClientCredential: 'OAuth2ClientCredential',
    UserAssignedManagedIdentity: 'UserAssignedManagedIdentity',
    UserAuth: AuthenticationType.UserAuth
};

export const adxAuthTypes = {
    ServicePrincipalAuthentication: 'ServicePrincipalAuthentication',
    MSIAuthentication: 'MSIAuthentication',
    UserAssignedManagedIdentityAuthentication: 'UserAssignedManagedIdentityAuthentication',
    UserAuth: AuthenticationType.UserAuth
};

export const sharePointOnlineAuthTypes = {
    ServicePrincipal: 'ServicePrincipal',
    UserAuth: AuthenticationType.UserAuth
};

export const office365AuthTypes = {
    ServicePrincipal: 'ServicePrincipal',
    UserAuth: AuthenticationType.UserAuth
};

export const lakehouseAuthTypes = {
    ServicePrincipalAuthentication: 'ServicePrincipal',
    MSIAuthentication: 'SystemAssignedManagedIdentity',
    UserAssignedManagedIdentity: 'UserAssignedManagedIdentity',
    UserAuth: AuthenticationType.UserAuth
};

export const warehouseAuthTypes = {
    ServicePrincipalAuthentication: 'ServicePrincipal',
    MSIAuthentication: 'SystemAssignedManagedIdentity',
    UserAssignedManagedIdentity: 'UserAssignedManagedIdentity'
};

export const dynamicsAxAuthTypes = {
    ServicePrincipal: 'ServicePrincipal',
    UserAuth: AuthenticationType.UserAuth
};

export enum RestBasedServiceAuthenticationType {
    BASIC = 'basic',
    TOKEN = 'token'
}

export enum workdayAuthTypes {
    BASIC = 'basic'
}

export enum saslMechanismType {
    PLAIN = 'PLAIN'
}

export enum kafkaAuthTypes {
    SASL = 'SASL'
}

export const snowflakeAuthTypes = {
    Basic: AuthenticationType.Basic,
    OAuth: 'Oauth'
};

export const snowflakeV2AuthTypes = {
    Basic: AuthenticationType.Basic,
    KeyPair: 'KeyPair',
    AADServicePrincipal: 'AADServicePrincipal'
};

export const artifactDmtsCredentialAuthTypes = {
    servicePrincipal: 'ServicePrincipal',
    userAuth: AuthenticationType.UserAuth
};

export enum ConnectionAuthKind {
    Key = 'Key',
    OAuth2 = 'OAuth2',
    Basic = 'Basic',
    Windows = 'Windows',
    SAS = 'SAS',
    Anonymous = 'Anonymous',
    ServicePrincipal = 'ServicePrincipal',
    WorkspaceIdentity = 'WorkspaceIdentity',
    KeyPair = 'KeyPair'
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ConnectionAuthKindDisplayNameMap: Map<ConnectionAuthKind, string> = new Map([
    [ConnectionAuthKind.Key, shellStringResources.AuthKind_Key],
    [ConnectionAuthKind.OAuth2, shellStringResources.AuthKind_OrganizationalAccount],
    [ConnectionAuthKind.Basic, shellStringResources.AuthKind_Basic],
    [ConnectionAuthKind.Windows, 'Windows'],
    [ConnectionAuthKind.SAS, 'SAS'],
    [ConnectionAuthKind.Anonymous, shellStringResources.AuthKind_Anonymous],
    [ConnectionAuthKind.ServicePrincipal, shellStringResources.AuthKind_ServicePrincipal],
    [ConnectionAuthKind.WorkspaceIdentity, shellStringResources.AuthKind_WorkspaceIdentity]
]);

/**
 * Auth types for SQL server linked service
 */
export enum SqlServerAuthType {
    SQLAuthentication = SQLAuthenticationType.SQL,
    WindowsAuthentication = SQLAuthenticationType.Windows,
    ManagedServiceIdentity = SQLAuthenticationType.ManagedServiceIdentity,
    UserAssignedManagedIdentity = SQLAuthenticationType.UserAssignedManagedIdentity
}

/**
 * Auth types to be flagged for HDInsight storage linked service auth
 */
export enum HDInsightStorageAuthType {
    hdinsightMSIAuth = 'hdi-msi',
    hdinsightUAMIAuth = 'hdi-uami'
}

/**
 * Auth types for HDInsight cluster auth
 */
export enum HDInsightClusterAuthTypes {
    NoAuthSelected = 'NoAuthSelected',
    BasicAuth = 'BasicAuth',
    MSIAuthentication = 'SystemAssignedManagedIdentity',
    UserAssignedManagedIdentity = 'UserAssignedManagedIdentity'
}

/**
 * Auth types for HDInsight Ondemand cluster resource group auth
 */
export enum HDInsightOndemandClusterResourceGroupAuthTypes {
    MSIAuthentication = 'SystemAssignedManagedIdentity',
    UserAssignedManagedIdentity = 'UserAssignedManagedIdentity',
    ServicePrincipalKey = 'ServicePrincipalKey'
}